export const OPEN_HOUR_COMPARISON_NOTE =
  "This hour's data is incomplete, so it is not included in the comparison.";

export const CLOSED_HOUR_COMPARISON_TOOLTIP =
  "Versus the same complete hours yesterday. The latest hour's data is incomplete and is not included in this comparison.";

export const SAME_HOUR_COMPARISON_TOOLTIP = 'Versus the same hour yesterday';

/** Hours present on both days, excluding the newest bucket still being filled. */
export function getClosedHourPairs(realtimeData) {
  const yesterdayByHour = new Map();
  (realtimeData?.yesterday || []).forEach(row => {
    if (!row.isOpenHour) yesterdayByHour.set(row.hour, row);
  });

  return (realtimeData?.today || []).reduce((pairs, today) => {
    if (today.isOpenHour) return pairs;
    const yesterday = yesterdayByHour.get(today.hour);
    if (!yesterday) return pairs;
    pairs.push({today, yesterday});
    return pairs;
  }, []);
}

export function metricTotals(rows) {
  const rev = rows.reduce((total, row) => total + row.rev, 0);
  const imp = rows.reduce((total, row) => total + row.imp, 0);
  const count = rows.length;

  return {
    Revenue: rev,
    Impressions: imp,
    eCPM: imp > 0 ? (rev / imp) * 1000 : 0,
    Viewability: count ? rows.reduce((total, row) => total + row.viewability, 0) / count : 0,
    CTR: count ? rows.reduce((total, row) => total + row.ctr, 0) / count : 0,
  };
}
